/***************************************************************
5/27/2017
Alexander Self
Timesheet modal table
- Table Summary of e to be submitted for review;
***************************************************************/
import React from 'react';
import user from '../img/user.jpg';
import { FloatingButton } from './inputs'

const EmployeeTable = ({ employees, onClick, noClick }) => {
  return (
    <table className="highlight bordered responsive-table centered">
      <thead>
        <tr>
          <th></th>
          <th>Name</th>
          <th>Position</th>
          <th>Position Type</th>
          <th>Department</th>
          <th>EID</th>
          { noClick ? <th></th> : <th>Remove</th> }
        </tr>
      </thead>
      <tbody>
        {
          employees.map((e) => {
            return (
              <tr key={Math.random()}>
                <td>
                  <img className="responsive-img circle"
                    height="30"
                    width="30"
                    alt=""
                    src={user}
                    onError={(e) => e.target.src='img/user.jpg' }
                  />
                </td>
                <td>{ e.firstName === null ? '' : e.firstName } { e.lastName === null ? '' : e.lastName }</td>
                <td>{ e.positionTitle }</td>
                <td>{ e.positionType }</td>
                <td>{ e.department }</td>
                <td>{ e.eid === null ? '' : e.eid }</td>
                { noClick ? <td></td> : <td><FloatingButton color={'red'} icon={'clear'} onclick={() => onClick(e)} /></td> }
              </tr>
            )
          })
        }
      </tbody>
    </table>
  );
};

export default EmployeeTable;



// WEBPACK FOOTER //
// ./src/components/employee_table.js